import React, { useEffect, useState } from "react";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Accordion, AccordionDetails, AccordionSummary, AutocompleteRenderGroupParams, List } from "@mui/material";
import { MeasureType } from "store/types";

interface Props {
  params: AutocompleteRenderGroupParams;
  popperRef: React.RefObject<any>;
  searchValue: string;
}

const GroupsTitles: Record<MeasureType, string> = {
  regular: "Regular",
  calculated: "Calculated"
};

export const MeasureGroup: React.FC<Props> = ({ params, popperRef, searchValue }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (searchValue.length >= 2) {
      setIsExpanded(true);
    }
  }, [searchValue]);

  return (
    <Accordion
      expanded={isExpanded}
      sx={{ borderRadius: "0 !important", color: "#0a3142", boxShadow: "none" }}
      onChange={(_, expanded) => {
        setIsExpanded(!isExpanded);
        if (expanded) {
          setTimeout(() => popperRef.current.update(), 300);
        }
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowForwardIosIcon sx={{ fontSize: "0.9rem", fill: "#5D7782" }} />}
        sx={{
          fontWeight: 600,
          fontSize: 15,
          flexDirection: "row-reverse",
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)"
          },
          "& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded": {
            margin: "0 0 0 16px"
          },
          "&.Mui-expanded": {
            minHeight: 48
          }
        }}
      >
        {GroupsTitles[params.group as MeasureType]}
      </AccordionSummary>
      <AccordionDetails sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <List sx={{ padding: 0, "& li": { fontSize: 16, marginLeft: "16px" } }}>{params.children}</List>
      </AccordionDetails>
    </Accordion>
  );
};
